<template>
  <div class="mic-com image-ad" :style="style">
    <component :is="componentName" :config="config"/>
    <div class="empty" v-if="!config.sub_entry.length">
      <van-image :src="img_empty" fit="cover" style="height: 250px;"/>
    </div>
  </div>
</template>

<script>
  import Common from "../mixins/Common";
  import HotAreaImage from "./HotAreaImage";
  import SimpleImage from "./SimpleImage";
  import Slider from "./Slider";
  import img_empty from '../../../../assets/image_ad_empty.png';

  export default {
	name: "ImageAd",
	props: {},
	mixins: [Common],
	components: {HotAreaImage, SimpleImage, Slider},
	data() {
	  return {
		img_empty
	  };
	},
	created() {
	},
	methods: {},
	computed: {
	  componentName() {
		return ["SimpleImage", "Slider", "HotAreaImage"][this.config.show_method];
	  },
	  style() {
		return {
		  marginLeft: this.config.page_margin / 2 + "px",
		  marginRight: this.config.page_margin / 2 + "px",
		  paddingTop: this.config.image_style ? "15px" : "",
		  paddingBottom: this.config.image_style ? "15px" : ""
		};
	  }
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .image-ad {
    .image-wrap {
      position: relative;
    }

    .link-title {
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;
      height: 30px;
      background-color: rgba(0, 0, 0, .3);
      color: #fff;
      line-height: 30px;
      padding: 0 10px;
    }
  }
</style>
